import { render, staticRenderFns } from "./AiWindow.vue?vue&type=template&id=3c6514d2&"
import script from "./AiWindow.vue?vue&type=script&lang=js&"
export * from "./AiWindow.vue?vue&type=script&lang=js&"
import style0 from "./AiWindow.vue?vue&type=style&index=0&id=3c6514d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports